import mitt from 'mitt'
import $ from 'jquery'

const detailsTriggerClassName = 'js-investor-type-selector-details-trigger'
const detailsTriggerActiveClassName = 'c-investor-type-selector__details-trigger--active'

const investorTypeSelector = target => {
  const emitter = mitt()
  const detailsTrigger = target.querySelectorAll(`.${detailsTriggerClassName}`)
  let open = {}

  emitter.on('showDetails', ({ detailsTarget }) => {
    if (open[detailsTarget]) {
      updateTriggers(getTriggerTarget(target)(detailsTarget), false)
      hideDetails(getDetailsTarget(target)(detailsTarget))
      open[detailsTarget] = null
      return
    }

    updateTriggers(getTriggerTarget(target)(), false)
    updateTriggers(getTriggerTarget(target)(detailsTarget), true)

    open = {}
    open[detailsTarget] = true
    hideDetails(getDetailsTarget(target)())
    showDetails(getDetailsTarget(target)(detailsTarget))
  })

  ;[ ...detailsTrigger ].forEach(trigger => {
    trigger.addEventListener('click', () => {
      emitter.emit('showDetails', {
        detailsTarget: dataset(trigger, 'target')
      })
    })
  })
}

export default investorTypeSelector

const showDetails = target => {
  [ ...target ].forEach(target => {
    target.style.display = 'block'
  })
}

const hideDetails = target => {
  [ ...target ].forEach(target => {
    target.style.display = 'none'
  })
}

const updateTriggers = (target, active) => {
  const method = active
    ? 'add'
    : 'remove'

  ;[ ...target ].forEach(target => {
    target.classList[method](detailsTriggerActiveClassName)
  })
}

const getDetailsTarget = target => id => id
  ? target.querySelectorAll(`#investor-type-${id}`)
  : target.querySelectorAll(`*[id^=investor-type-]`)

const getTriggerTarget = target => id => id
  ? target.querySelectorAll(`.${detailsTriggerClassName}[data-target='${id}']`)
  : target.querySelectorAll(`.${detailsTriggerClassName}`)

const dataset = (target, key) =>
  $(target).data(key)
